<div [@enterAnimation]
     class="w-full h-fit
            mt-16 lg:mt-32
            overflow-y-auto overflow-x-hidden">
  <div class="w-full flex flex-col">
    <!--  Top Section  -->
    <div class="w-full bg-white
                border-b-2 border-divider
                p-[0.938rem]">
      <div class="w-full max-w-container
                        mx-auto flex

                        flex-row flex-nowrap
                        justify-between items-center">
        <h2 class="text-lg text-darker font-semibold">
          Over Ons
        </h2>

        <div class="hidden md:flex
                            gap-x-1.5 justify-end">
                  <span [routerLink]="['/']"
                        class="cursor-pointer hover:text-primary text-secondary-gray">
                    Home /
                  </span>

          <div class="text-darker">
            Over Ons
          </div>
        </div>
      </div>
    </div>
    <div class="w-full h-[33.813rem]
                md:h-[60rem]
                md:max-h-screen
                bg-[url('https://firebasestorage.googleapis.com/v0/b/schoonmaakwoede-productie.appspot.com/o/images%2Fcontact_schoonmaakwoede_mobiel.png?alt=media&token=54db3417-0bc5-4651-a8c5-2a8c22087a4d')]
                md:bg-[url('https://firebasestorage.googleapis.com/v0/b/schoonmaakwoede-productie.appspot.com/o/images%2Fcontact_schoonmaakwoede_desktop.png?alt=media&token=a2869925-c53a-4e4b-a907-250fb4d16baf')]
                bg-no-repeat
                bg-top
                md:bg-right
                 bg-cover
                flex flex-col">
      <div class="w-full h-full
                  max-w-container flex
                  p-[0.938rem] container:p-0
                  mr-auto mx-auto">
        <div class="w-full max-w-[54.938rem]
                    min-h-fit
                    mt-auto md:my-auto
                    px-[1.438rem] md:px-[6.563rem]
                    py-[2.313rem] md:py-[5rem]
                    bg-blur rounded-[2.25rem]">
          <div class="w-full flex flex-col
                                gap-4 md:gap-7">
            <h1 class="w-full text-[1.75rem]
                                    text-dark-blue leading-[2.275rem]
                                    md:leading-[3.9rem]
                                    md:text-5xl font-semibold">
              Schoonmaakwoede. Wie we zijn en wat we doen.
            </h1>
          </div>
        </div>
      </div>
    </div>
    <!--  Top Section  -->

    <!--  Body  -->
    <div class="w-full bg-white
                p-[0.938rem] pb-9">
      <div class="w-full max-w-container
                  mx-auto mt-12
                  flex flex-col gap-16">
        <div class="w-full flex
                    flex-col gap-12">
          <div class="w-full flex
                      flex-col mx-auto gap-2">
            <div class="w-full text-2xl
                            leading-[2.25rem]
                            md:text-[2.375rem]
                            md:leading-[3.563rem]
                            md:text-center
                            text-darker font-semibold">
              Organisatie
            </div>

            <div class="h-1 w-32
                            bg-divider md:mx-auto
                            my-[0.9rem] md:my-[1rem]"></div>

            <div class="w-full text-gray">
              Schoonmaakwoede heeft een landelijk netwerk van eigen vestigingen en franchisers. We hanteren overal in
              Nederland dezelfde werkwijze, controle en kwaliteit. Al onze schoonmakers zijn gecertificeerd. Ze volgen
              onze interne opleiding en worden getraind op expertise, degelijkheid en omgangsvormen. Pas als ze de
              opleiding met succes hebben afgerond, mogen zij bij je aan de slag.
            </div>
          </div>

          <div class="w-full
                      flex flex-col
                      mx-auto gap-2">
            <div class="w-full text-2xl
                            leading-[2.25rem]
                            md:text-[2.375rem]
                            md:leading-[3.563rem]
                            md:text-center
                            text-darker font-semibold">
              Grondige Schoonmaak
            </div>

            <div class="h-1 w-32
                            bg-divider md:mx-auto
                            my-[0.9rem] md:my-[1rem]"></div>

            <div class="w-full text-gray">
              Onze naam staat voor perfectie in grondige schoonmaak. Laat je ontzorgen en ervaar het gevoel van een
              heerlijk schoon huis of bedrijf. Of het nu gaat om een groot of een klein project, wij garanderen een
              blinkend resultaat. Waar ook in Nederland. Ons unieke online begrotings- en bestelsysteem maakt het
              makkelijk..
            </div>
          </div>

          <div class="w-full
                      flex flex-col
                      mx-auto gap-2">
            <div class="w-full text-2xl
                            leading-[2.25rem]
                            md:text-[2.375rem]
                            md:leading-[3.563rem]
                            md:text-center
                            text-darker font-semibold">
              Milieu
            </div>

            <div class="h-1 w-32
                            bg-divider md:mx-auto
                            my-[0.9rem] md:my-[1rem]"></div>

            <div class="w-full text-gray">
              Wij rijden voor en hebben de beste professionele middelen en materialen bij ons. Het enige wat we nodig
              hebben is water en stroom. Schoonmaakwoede gebruikt zoveel mogelijk milieuvriendelijke middelen. Want wij
              houden het milieu ook graag schoon!
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  Body  -->

  </div>
</div>
